import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=6a155580&scoped=true&"
import script from "./EditAccount.vue?vue&type=script&lang=ts&"
export * from "./EditAccount.vue?vue&type=script&lang=ts&"
import style0 from "./EditAccount.vue?vue&type=style&index=0&id=6a155580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a155580",
  null
  
)

export default component.exports